import { render } from "./FileEditor.vue?vue&type=template&id=29e1d446&scoped=true"
import script from "./FileEditor.vue?vue&type=script&lang=js"
export * from "./FileEditor.vue?vue&type=script&lang=js"

import "./FileEditor.vue?vue&type=style&index=0&id=29e1d446&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29e1d446"]])

export default __exports__